import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Observable, Subject, take } from 'rxjs';
import { ClientEntity } from 'src/app/models/entities/client.entity';
import { BillableItemEntity } from 'src/app/models/entities/project.entity';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { TenantService } from '../../services/tenant.service';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private tenantId: string = '';
  private dbPath: string = '';
  public new: boolean = false;
  public currentClient: ClientEntity | undefined;
  public newClient: boolean = false; // Renamed from 'new' to 'newClient' to avoid keyword conflicts


  constructor(private afs: AngularFirestore, private afAuth: AngularFireAuth, private tenantService: TenantService) {
    this.tenantService.tenantId$.subscribe(tenantId => {
      if (tenantId) {
        this.tenantId = tenantId;
        this.dbPath = `${this.tenantId}/data/clients`;
      }
    });
  }

  public save(client: any): Observable<any> {
    let result$: Subject<any> = new Subject();
    const clientsCollection: AngularFirestoreCollection<ClientEntity> = this.afs.collection(this.dbPath);

    client.createdAt = new Date();
    client.updatedAt = new Date();

    clientsCollection.add(client).then(docRef => {
      const updatedClient = { ...client, key: docRef.id };
      this.update(updatedClient);
      result$.next(updatedClient);
    });

    return result$.asObservable();
  }

  public update(client: any): Promise<void> {
    const clientDoc: AngularFirestoreDocument<ClientEntity> = this.afs.doc(`${this.dbPath}/${client.key}`);
    return clientDoc.update(client);
  }

  public set(key: string, client: ClientEntity): Promise<void> {
    const clientDoc: AngularFirestoreDocument<ClientEntity> = this.afs.doc(`${this.dbPath}/${key}`);
    return clientDoc.set(client);
  }

  public updateItem(clientKey: string, client: ClientEntity): Promise<void> {
    const clientDoc: AngularFirestoreDocument<ClientEntity> = this.afs.doc(`${this.dbPath}/${clientKey}`);
    // Assuming billableItems is structured correctly for Firestore; otherwise, needs adjustment
    return clientDoc.update(client);
  }


  public get(): Observable<ClientEntity[]> {
    return this.afs.collection<ClientEntity>(this.dbPath).valueChanges({ idField: 'key' });
  }

  public getItem(key: string): AngularFirestoreDocument<ClientEntity> {
    return this.afs.doc<ClientEntity>(`${this.dbPath}/${key}`);
  }


  public deleteItem(key: string): Promise<void> {
    return this.afs.doc<ClientEntity>(`${this.dbPath}/${key}`).delete();
  }
}
